import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import classes from "../analytics.module.css"
import { DrillTable, DrillTitle } from "../cards/AnalyticsCard"
import { RankBadge, RankColumn, RankTable } from "../cards/RankTable"
import { SalesAnalyticsTopProducts, TopProductRow } from "../types"
import { formatInt, formatMnt } from "../utils"

type Props = {
  data: SalesAnalyticsTopProducts | undefined
  isLoading: boolean
}

export function TopProductsCard({ data, isLoading }: Props) {
  const { t } = useTranslation(["dashboard"])
  const rows = data?.data.rows ?? []

  const columns: RankColumn<TopProductRow>[] = [
    {
      key: "rank",
      header: "#",
      width: "56px",
      render: (_row, idx) => <RankBadge n={idx + 1} />
    },
    {
      key: "name",
      header: t("analytics.tables.product", { defaultValue: "Бараа" }),
      render: row => row.productName
    },
    {
      key: "amount",
      header: t("analytics.tables.amount", { defaultValue: "Дүн" }),
      align: "right",
      render: row => <Text component="span" className={classes.amount}>{formatMnt(row.totalAmount)}</Text>
    },
    {
      key: "qty",
      header: t("analytics.tables.qty", { defaultValue: "Тоо" }),
      align: "right",
      render: row => formatInt(row.totalQty)
    }
  ]

  return (
    <RankTable<TopProductRow>
      title={t("analytics.tables.topProducts", { defaultValue: "Топ 10 бараа" })}
      rows={rows}
      columns={columns}
      isLoading={isLoading}
      rowKey={row => row.productId}
      renderDrill={row => (
        <>
          <DrillTitle>{row.productName} · {t("analytics.tables.partnerBreakdown", { defaultValue: "Харилцагчийн задаргаа" })}</DrillTitle>
          <DrillTable
            headers={[
              t("analytics.tables.partner", { defaultValue: "Харилцагч" }),
              t("analytics.tables.qty", { defaultValue: "Тоо" }),
              t("analytics.tables.amount", { defaultValue: "Дүн" })
            ]}
            rows={row.breakdown.map(b => [
              b.partnerName,
              `${formatInt(b.qty)} ${t("analytics.tables.pieces", { defaultValue: "ш" })}`,
              formatMnt(b.amount)
            ])}
          />
        </>
      )}
    />
  )
}
